module.exports = __webpack_public_path__ + "static/media/Nicola casey 4.1.27b633d9.jpg";